import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import createbuild from "../../../assets/img/post/add-pop-thumb.svg";
import { getAllCommunityMemberTypes } from "../../../services/apiCommunity";
import Validation from "../../../commonComponents/Validation";
import { ApiHelper } from "../../../helpers/ApiHelper";
import { API } from "../../../services/api";
import { checkCharacterLimit } from "../../../utils/textLimiter";
import "../../../assets/css/text-limit.css";
const CreateCommunity = (props) => {
  const MAX_POST_LENGTH = 100;
  const [characterLimit, setCharacterLimit] = useState({
    isOverLimit: false,
    remaining: MAX_POST_LENGTH,
    limitedText: ''
  });
  const [Membertypes, SetMembertypes] = useState([]);
  const [Errors, setErrors] = useState({});
  const [isCommunityExist, setIsCommunityExist] = useState(false);
  const userData = JSON.parse(localStorage.getItem('userData'));

  const [FormData, setFormData] = useState({
    communityname: "",
    membertype: "",
    reason: "",
  });

  useEffect(() => {

    FetchMemberTypes();
  }, []);

  const ClosePopup = () => {
    props.handleClose();
  }
  const handleChange = async (event) => {
    const { name, value } = event.target;
    if (name === "communityname") {
      const limitInfo = checkCharacterLimit(value, MAX_POST_LENGTH);
      setCharacterLimit(limitInfo);
      if (!limitInfo.isOverLimit || value.length < FormData.communityname.length) {
        setFormData(prevData => ({
          ...prevData,
          [name]: limitInfo.limitedText,
        }));
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Clear only the error for the current field
    }));
  }

  const FetchMemberTypes = async () => {
    let listMemberTypes = await getAllCommunityMemberTypes({ "filter": "all" });
    if (listMemberTypes.status === true)
      SetMembertypes(listMemberTypes.data || []);

  }
  const validateForm = () => {
    const newErrors = {};
    if (!FormData.communityname) newErrors.communityname = true;
    if (!FormData.membertype) newErrors.membertype = true;
    if (!FormData.reason) newErrors.reason = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 
  const RequestNewCommunity = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    const formData = {
      community: FormData.communityname,
    };
    try {
      const resData = await ApiHelper.post(API.checkCommunityExist, formData);
      const exists = resData.data.status;
      if (exists) {
        setIsCommunityExist(true);
        return;
      } else {
        setIsCommunityExist(false);
      }

      FormData.userid = userData._id;
      props.RequestCommunity(FormData);

    } catch (error) {
      console.error("Error verifying community:", error);
    }
  };


  return (

    <>
      <Modal show={props.isNewCommunity} onHide={props.handleClose} dialogClassName="custom-modal modal-dialog-scrollable modal-dialog-centered">
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="mod-bor-icon" >
              <img src={createbuild} className="mod-icon"></img>
            </div>
            <div className="header">
              <div className="signuup">Create a new Community</div>
              <p className="Stronger"> Stronger every day, starting today</p>

            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <form>
            <div className="mb-5">
              <div className="mb-1 row">
                <label for="inputPassword" className="col-sm-4 col-form-label font ">Community Name <span className="required"> * </span></label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control search"
                    name="communityname"
                    value={FormData.communityname}
                    onChange={handleChange}
                    maxLength={MAX_POST_LENGTH}
                  />
                  <div className={`character-counter ${characterLimit.isOverLimit ? 'text-danger' : 'text-muted'}`}>
                    {characterLimit.remaining} characters remaining
                    {characterLimit.remaining <= 0 && (
                      <span className="limit-warning"> (Maximum limit reached)</span>
                    )}
                  </div>

                  {Errors.communityname && (
                    <Validation message={'Please type your new community name'} />
                  )}
                  {FormData.communityname !== "" && isCommunityExist ? (
                    <Validation message={'Your requested community alreadt exist'} />
                  ) : null}
                </div>

              </div>

              <div className="mb-1 row">
                <label for="inputPassword" className="col-sm-4 col-form-label font ">Reason for request <span className="required"> * </span></label>
                <div className="col-sm-8">
                  <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" name="reason" value={FormData.reason} onChange={handleChange}></textarea>
                  {Errors.reason && (
                    <Validation message={'Please type your reason'} />
                  )}
                </div>

              </div>


              <div className="mt-2 row">
                <label for="inputPassword" className="col-sm-4 col-form-label font ">I'm joining this community because...</label>
                <div className="col-sm-8">
                  <select className="form-select font join-A-comm" aria-label="Default select example" name="membertype" value={FormData.membertype} onChange={handleChange}>
                    <option value="Select Member type " className="font join-A-comm-drop">Select Member type</option>


                    {Membertypes.map((type, index) => (
                      <option key={index} value={type._id} className="font join-A-comm-drop">
                        {type.memberTypeName || "Select Member type"}
                      </option>
                    ))}

                  </select>
                  {Errors.membertype && (
                    <Validation message={'Please choose your member type'} />
                  )}
                </div>
              </div>

            </div>
          </form>

        </Modal.Body>
        <Modal.Footer className="full-w" >
          <button
            type="button"
            className="cancel-btn" onClick={() => ClosePopup()}>
            Cancel
          </button>

          <button className="next-btn" onClick={(e) => RequestNewCommunity(e)}>
            Next
          </button>
        </Modal.Footer>

      </Modal>


    </>
  );

};
export default CreateCommunity;
